/**
 * @class Oskari.userinterface.event.ExtensionUpdatedEvent
 *
 * Sent after Extension view state has changed
 *
 */
Oskari.clazz.define('Oskari.userinterface.event.ExtensionUpdatedEvent', function (extension, viewstate, viewinfo) {
  this._creator = null;
  this._extension = extension;
  this.viewstate = viewstate;
  this.viewinfo = viewinfo;
}, {
  __name: 'userinterface.ExtensionUpdatedEvent',
  getName: function getName() {
    return this.__name;
  },
  /**
   * @method returns Extension
   */
  getExtension: function getExtension() {
    return this._extension;
  },
  /**
   * @method getViewState
   * returns 'close','attach','detach','minimize','restore','minimize'
   */
  getViewState: function getViewState() {
    return this.viewstate;
  },
  setViewState: function setViewState(viewstate) {
    this.viewstate = viewstate;
  },
  /**
   * @method getViewInfo
   * returns a property with view dimension info (currently WHEN in restored or detached state)
   */
  getViewInfo: function getViewInfo() {
    return this.viewinfo;
  },
  setViewInfo: function setViewInfo(viewinfo) {
    this.viewinfo = viewinfo;
  }
}, {
  'protocol': ['Oskari.mapframework.event.Event']
});

/* Inheritance */